import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ChangingRoomGroup = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="changing-room-group"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="3" width="60" height="7" rx="1" />
      <rect y="38" width="60" height="6" rx="1" />
      <rect x="4" y="50" width="52" height="3" rx="1" />
      <rect x="6" y="40" width="20" height="3" rx="1" transform="rotate(90 6 40)" />
      <rect x="57" y="40" width="20" height="3" rx="1" transform="rotate(90 57 40)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52 8a1 1 0 011 1v5a1 1 0 102 0 1 1 0 112 0 3 3 0 01-5 2.236A3 3 0 0147 14a1 1 0 112 0 1 1 0 102 0V9a1 1 0 011-1zM30 8a1 1 0 011 1v5a1 1 0 102 0 1 1 0 112 0 3 3 0 01-5 2.236A3 3 0 0125 14a1 1 0 112 0 1 1 0 102 0V9a1 1 0 011-1zM8 8a1 1 0 011 1v5a1 1 0 102 0 1 1 0 112 0 3 3 0 01-5 2.236A3 3 0 013 14a1 1 0 112 0 1 1 0 102 0V9a1 1 0 011-1z"
      />
    </svg>
  );
};
/* eslint-enable max-len */

ChangingRoomGroup.defaultProps = {
  className: null,
};

ChangingRoomGroup.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default ChangingRoomGroup;
